import React from 'react';

function DashboardShell({
  header,
  overlays,
  settingsModal,
  progress,
  buddy,
  fit,
  achievements,
  tasks,
  quickActions,
  footer,
  backToTop,
}) {
  return (
    <div className="dashboard-shell">
      {header}
      {overlays}
      {settingsModal}
      {progress}
      {buddy}
      {fit}
      {achievements}
      {tasks}
      {quickActions}
      {footer}
      {backToTop}
    </div>
  );
}

export default DashboardShell;
